import { render, staticRenderFns } from "./NewTreeview.vue?vue&type=template&id=40a01452&scoped=true"
import script from "./NewTreeview.vue?vue&type=script&lang=js"
export * from "./NewTreeview.vue?vue&type=script&lang=js"
import style0 from "./NewTreeview.vue?vue&type=style&index=0&id=40a01452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a01452",
  null
  
)

export default component.exports